var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat0Geral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 850,
    height: 450,
    viewBox: "0 0 850 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_974)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 850,
    height: 450,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_197_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.906 269.71C537.906 269.71 554.312 203.969 556.995 142.64C536.7 121.585 503.218 110.973 425.861 119.588C383.741 124.28 318.239 112.958 318.938 114.232C318.938 114.232 301.745 183.41 303.532 234.785C303.532 234.785 345.652 258.873 418.2 251.637C490.748 244.4 537.906 269.71 537.906 269.71Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.359 298.734C240.123 274.699 243.801 250.213 245.352 225.548C233.663 213.434 214.382 207.325 169.834 212.287C145.581 214.989 107.858 208.466 108.259 209.202C108.259 209.202 98.3574 249.04 99.3865 278.631C99.3865 278.631 123.64 292.501 165.424 288.334C207.207 284.167 234.359 298.734 234.359 298.734Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.732 298.734C745.496 274.699 749.174 250.213 750.725 225.548C739.036 213.434 719.755 207.325 675.207 212.287C650.954 214.989 613.231 208.466 613.633 209.202C613.633 209.202 603.731 249.04 604.76 278.631C604.76 278.631 629.013 292.501 670.797 288.334C712.581 284.167 739.732 298.734 739.732 298.734Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.229 362.699H501.758L466.008 343.176L388.55 316.009C388.55 316.009 363.097 304.967 353.653 323.177C345.159 339.595 354.502 349.103 368.122 356.737C381.741 364.371 403.871 375.413 403.871 375.413L378.337 384.751H292.369L255.779 366.075C255.779 366.075 235.351 361.839 231.095 377.111C226.838 392.382 228.54 392.392 236.201 398.335L293.228 426.355L389.412 446.729H621.238",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.409 384.631L290.958 352.231C290.958 352.231 288.697 340.264 302.31 335.614C304.623 334.624 307.12 334.134 309.637 334.178C312.153 334.222 314.632 334.798 316.909 335.868C319.186 336.939 321.209 338.479 322.844 340.387C324.48 342.295 325.691 344.527 326.397 346.936C330.864 359.177 334.611 371.668 337.619 384.344",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.784 248.688C468.622 248.688 496.865 220.521 496.865 185.776C496.865 151.03 468.622 122.863 433.784 122.863C398.945 122.863 370.703 151.03 370.703 185.776C370.703 220.521 398.945 248.688 433.784 248.688Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.398 286.637C194.461 286.637 210.726 270.416 210.726 250.406C210.726 230.396 194.461 214.174 174.398 214.174C154.334 214.174 138.07 230.396 138.07 250.406C138.07 270.416 154.334 286.637 174.398 286.637Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.35 286.461C703.316 284.489 717.899 266.748 715.922 246.836C713.945 226.923 696.157 212.379 676.191 214.351C656.225 216.323 641.642 234.064 643.619 253.976C645.597 273.889 663.385 288.433 683.35 286.461Z",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.783 229.185C188.01 236.806 193.149 275.637 175.942 270.671C168.755 268.596 169.693 257.244 162.874 253.26C173.616 252.97 172.515 241.729 170.339 238.966C168.164 236.203 160.787 233.531 159.033 246.134C158.556 249.568 156.507 270.942 156.468 276.22C156.553 268.384 158.585 229.752 150.134 242.39",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.561 236.604C189.154 230.687 174.4 234.756 178.556 245.287C179.922 248.75 185.047 248.545 188.046 248.848C194.73 249.539 200.091 254.468 195.733 260.639C194.556 262.233 192.886 263.397 190.98 263.95C189.074 264.504 187.039 264.417 185.188 263.702C184.056 263.34 183.024 262.72 182.173 261.893C181.321 261.066 180.674 260.053 180.281 258.934C179.888 257.815 179.76 256.621 179.908 255.445C180.056 254.268 180.476 253.142 181.134 252.155",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.159 229.185C693.387 236.806 698.526 275.637 681.319 270.671C674.132 268.596 675.066 257.244 668.251 253.26C678.993 252.97 677.892 241.729 675.716 238.966C673.54 236.203 666.164 233.531 664.409 246.134C663.932 249.568 661.884 270.942 661.845 276.22C661.93 268.384 663.962 229.752 655.51 242.39",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.931 236.604C694.524 230.687 679.77 234.756 683.926 245.287C685.291 248.75 690.417 248.545 693.416 248.848C700.1 249.539 705.461 254.468 701.103 260.639C699.926 262.233 698.256 263.397 696.35 263.95C694.444 264.504 692.409 264.417 690.558 263.702C689.426 263.34 688.394 262.72 687.542 261.893C686.691 261.066 686.043 260.053 685.651 258.934C685.258 257.815 685.13 256.621 685.278 255.445C685.426 254.268 685.846 253.142 686.503 252.155",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.092 148.909C457.436 162.137 466.361 229.573 436.501 220.951C424.005 217.344 425.645 197.636 413.787 190.712C432.441 190.21 430.526 170.687 426.746 165.894C422.967 161.101 410.157 156.445 407.112 178.337C406.282 184.3 402.728 221.414 402.659 230.583C402.806 216.976 406.331 149.89 391.663 171.837",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.328 161.812C459.408 151.535 433.792 158.605 441.009 176.891C443.384 182.905 452.28 182.534 457.494 183.081C469.101 184.283 478.402 192.856 470.839 203.556C468.797 206.321 465.899 208.339 462.594 209.301C459.288 210.262 455.757 210.113 452.544 208.876C441.254 204.892 442.456 194.104 445.504 188.822",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.259 446.742H799.033",
    stroke: "#3A4156",
    strokeWidth: 5.80445,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 850,
    height: 450,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_197_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 850,
    height: 540,
    fill: "white",
    transform: "translate(0 -90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat0Geral);
export default __webpack_public_path__ + "static/media/cat-0-geral.b5ac6a7c42db58f152977ccd92cf1068.svg";
export { ForwardRef as ReactComponent };